// extracted by mini-css-extract-plugin
module.exports = {"header-drawer":"drawer_header-drawer__oH6D_","collapse":"drawer_collapse__x7gOQ"};